import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import PropTypes from 'prop-types';
import Global from '../../store/global-selectors';
import * as Actions from '../../store/shipments/filtering/shipments.filtering.actions';
import { EditFilterViewModal } from '../../components/modals/edit-filterview-modal';
import { useSelectedShippingViewId } from '../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';

const savedFilterViewsSelector = createSelector(
  (savedFilterViews) => savedFilterViews,
  (_, viewId) => viewId,
  (savedFilterViews, viewId) => {
    return savedFilterViews.filter((view) => view.gridViewId === viewId);
  },
);

export const EditShippingFilterviewModalContainer = React.memo(({ modalFrameworkMethods }) => {
  const dispatch = useDispatch();
  const savedFilterViews = useSelector(Global.selectShipmentsFilteringSavedFilterViews);
  const activeFilterView = useSelector(Global.selectShipmentsFilteringActiveFilterView);
  const viewId = useSelectedShippingViewId();
  const realSavedFilterViews = savedFilterViewsSelector(savedFilterViews, viewId);
  const saveExistingFilterViewRequest = useCallback(
    (viewWithNewFilters) => {
      dispatch(Actions.saveExistingFilterViewRequest(viewWithNewFilters));
    },
    [dispatch],
  );
  const deleteViewModalAction = useCallback(() => {
    dispatch(Actions.launchDeleteViewModal());
  }, [dispatch]);

  return (
    <EditFilterViewModal
      activeFilterView={activeFilterView}
      deleteViewModalAction={deleteViewModalAction}
      modalFrameworkMethods={modalFrameworkMethods}
      savedFilterViews={realSavedFilterViews}
      saveExistingFilterViewRequest={saveExistingFilterViewRequest}
    />
  );
});

EditShippingFilterviewModalContainer.propTypes = {
  modalFrameworkMethods: PropTypes.shape({
    cancelModal: PropTypes.func,
    closeModal: PropTypes.func,
  }).isRequired,
};
